export const NUMBER_WIZARD_DATA = [
  {
    text: "Fill up your details and proceed next steps.",
  },
];

export const BUSSINES_VERTICAL_DATA = [
    {
      activeTab: 1,
      tittle: "Choose account",
    },
    {
      activeTab: 2,
      tittle: "Business settings",
    },
    {
      activeTab: 3,
      tittle: "Contact details",
    },
    {
      activeTab: 4,
      tittle: "Pay details",
    },
    {
      tittle: "completed",
    },
  ];
  
  export const SELECT_AMOUNT_DATA = [
    {
      iconName: "fa-university",
      tittle: "Business",
    },
    {
      iconName: "fa-user",
      tittle: "Personal ",
    },
  ];

  export const VARIATION_BOX_DATA = [
    {
      tittle: "Tivo",
      details: "2-3 Members",
    },
    {
      tittle: "Cuba",
      details: "4-5 Members",
    },
    {
      tittle: "Multikart",
      details: "2 Member",
    },
    {
      tittle: "Roxo",
      details: "1 Member",
    },
  ];

  export const POPULER_BANK_LIST = [
    {
      imageName: "hdfc.png",
      bankName: "ABC BANK",
    },
    {
      imageName: "Bank-of-Baroda.png",
      bankName: "XYZ BANK",
    },
    {
      imageName: "idbi.png",
      bankName: "PQR BANK",
    },
    {
      imageName: "rbl.png",
      bankName: "DEF BANK",
    },
    {
      imageName: "us-bank.png",
      bankName: "MNO BANK",
    },
    {
      imageName: "axis.png",
      bankName: "WXY BANK",
    },
    {
      imageName: "SCB.png",
      bankName: "STD BANK",
    },
  ];

  export const CUSTOM_HORIZONTAL_DATA = [
    {
      activeTab: 1,
      iconName: "fa-user",
      tittle: "Personal info",
    },
    {
      activeTab: 2,
      iconName: "fa-chain-broken",
      tittle: "Connect bank account",
    },
    {
      activeTab: 3,
      iconName: "fa-group",
      tittle: "Inquiries",
    },
    {
      iconName: "fa-group",
      tittle: "Completed ",
    },
  ];

  export const MODAL_ONE_DATA = [
    {
      iconClassName: "fa-spin fa-cog",
      tittle: "2FA Authenticator",
      description: "Obtain codes from a authy/google authenticator/ios 15 etc.",
    },
    {
      iconClassName: "fa-comments",
      tittle: "SMS",
      description:
        "The backup login method will be sent to you via SMS if you require it.",
    }
  ]


  export const CURRENT_CART_DATA = [
    {
      imagePath: "product/13.png",
      productName: "T-shirt",
      productSum: "$98 * 2",
      price: "$400",
    },
    {
      imagePath: "email-template/4.png",
      productName: "Headphone",
      productSum: "$4*2",
      price: "$450",
    },
    {
      imagePath: "product/2.png",
      productName: "T-shirt ",
      productSum: "$10*2",
      price: "$234",
    },
    {
      imagePath: "dashboard-2/product/2.png",
      productName: "Chairs ",
      productSum: "$98*2",
      price: "$200",
    },
  ];

  export const CURRENT_CART_FOOTER = [
    {
      footerTittle: "Sub Total :",
      price: "1284.00",
    },
    {
      footerTittle: "Discount :",
      price: "20.00",
    },
    {
      footerTittle: "Shipping Charge :",
      price: "100.78",
    },
    {
      footerTittle: "Tax :",
      price: "205.34",
    },
    {
      footerTittle: "Total (USD) :",
      price: "1569.7",
    },
  ];

  export const HOME_AND_OFFICE_DATA = [
    {
      value: "shipping-choose1",
      label: "Home",
      name: "Filomena Green ",
      adress: "2211 Fruitville Rd, Sarasota, Florida, US 34237",
      contact: "(941) 321-5643",
    },
    {
      value: "shipping-choose2",
      label: "Work",
      name: "Ms. Ila Runte DDS",
      adress: " 1531 E 23rd St S, Independence, Mississippi, US 64055",
      contact: "(816) 252-4500",
    },
  ];

  export const SHIPPING_FORM_DATA = [
    {
      text: "Fill up your true details and next proceed.",
    },
  ];
  
  export const SHIPPING_NAV_DATA = [
    {
      activeTab: 1,
      iconClassName: "fa-user",
      tittle: "Billing",
    },
    {
      activeTab: 2,
      iconClassName: "fa-truck",
      tittle: "Shipping",
    },
    {
      activeTab: 3,
      iconClassName: "fa-money",
      tittle: "Payment",
    },
    {
      iconClassName: "fa-check-square",
      tittle: "Finish",
    },
  ];

  export const SHIPPING_METHOD_DATA = [
    {
      value: "standardDelivery",
      label: "Standard Delivery - Free",
      details: "Estimated 5-7 days shipping",
    },
    {
      value: "expressDelivery",
      label: "Express Delivery - $24",
      details: "Estimated 1-2 days shipping",
    },
  ];

  export const STUDENT_VALIDATION_DATA = [
    {
      text: "Please make sure fill all the filed before click on next button.",
    },
  ];

  export const VERTICAL_VALIDATION_DATA = [
    {
      text: "Fill up your true details and next proceed.",
    },
  ];
  
  export const VARTICAL_WIZARD_TAB_DATA = [
    {
      iconClassName: "fa-user",
      tittle: "Your Info",
      tittleInforMation: "Add your details ",
    },
    {
      iconClassName: "fa-chain-broken",
      tittle: "Cart Info",
      tittleInforMation: "Add your a/c details",
    },
    {
      iconClassName: "fa-group",
      tittle: "Net Banking",
      tittleInforMation: "Choose your bank",
    },
  ];

  export const NETBANKING_LIST = [
    {
      bankList: ["Industrial & Commercial Bank", "Agricultural Bank", "JPMorgan Chase & Co."],
    },
    {
      bankList: ["Construction Bank Corp.", "Bank of America", "HDFC Bank"],
    },
  ];